import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'

import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import { getUSDPrice } from '@/helpers/pkgPricing'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getCurrencyRates } from '../currencyService'

export const useCurrencyRates = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CURRENCY_RATES],
    queryFn: () => getCurrencyRates(),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}

export const useConvertToUSD = () => {
  const { data: currencyRates } = useCurrencyRates()
  const EURToUSD = currencyRates?.EURToUSD ?? 0
  const GBPToUSD = currencyRates?.GBPToUSD ?? 0
  const AEDToUSD = currencyRates?.AEDToUSD ?? 0
  return useCallback(
    (price: number, warehouse: PkgWarehouse) => {
      return getUSDPrice({ price, warehouse }, EURToUSD, GBPToUSD, AEDToUSD)
    },
    [EURToUSD, GBPToUSD, AEDToUSD]
  )
}
